// extracted by mini-css-extract-plugin
module.exports =  {"root":"VSyfPH7","left":"y7hpDhn","logo":"w_tM90G","picture":"wpND0Rt","text":"WLqKyPU","button":"pABcYxm"};